import { HttpErrorResponse } from '@angular/common/http';

import {
  createEntityCollectionStore,
  EntityState,
  getEntityCollectionActions,
  PickActions,
} from '@recruitee/ngrx';
import {
  FilterPayload,
  SwimlaneConfig,
  GroupsQueryParams,
  SwimlanesState,
} from '@recruitee/views-types';

export interface FetchSwimlanesPayload {
  operator: string;
  layout: { type: 'board'; swimlane: SwimlaneConfig } | null;
  filters: FilterPayload[];
  group: { configId: string } | null;
}

export const getStoreSwimlaneId = (
  dataSourceId: string,
  groupingId: string,
  swimlaneGroupId?: string,
) => `${dataSourceId}:${groupingId}:${swimlaneGroupId}`;
const idSelector: any = (entity: { id: number }) => entity.id;
const { actions, selectors, reducer, namespace } = createEntityCollectionStore<SwimlanesState>()(
  'ViewsSwimlanes',
  {
    idSelector,
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);
      const fetch = (
        state: EntityState<SwimlanesState>,
        payload: {
          storeSwimlaneGroupId: string;
          dataSourceId: string;
          data: FetchSwimlanesPayload;
          queryParams?: GroupsQueryParams;
        },
      ) =>
        adapter.markAsPending(state, {
          scope: null,
          entities: [payload.storeSwimlaneGroupId],
        });

      return {
        fetch,
        fetchSuccess: (state, payload: { data: SwimlanesState; concat: boolean }) => {
          const currentData = state.entityMap[payload.data.id];
          const data = payload.concat
            ? {
                ...payload.data,
                swimlanes: [...(currentData?.swimlanes ?? []), ...payload.data.swimlanes],
              }
            : payload.data;
          return defaultActions.fetchOneSuccess(state, { data });
        },
        fetchFailed: (state, payload: { error: HttpErrorResponse; id: string }) =>
          defaultActions.fetchOneFailed(state, payload),

        clear: (state, payload: { dataSourceId: string }) => {
          const recordsIds = Object.keys(state.entityMap).filter(
            id => id.split(':')[0] === payload.dataSourceId,
          );
          return adapter.removeMany(state, recordsIds);
        },
      };
    },
  },
);
export const ViewSwimlaneActions: PickActions<typeof actions, 'fetch'> &
  Pick<typeof actions, 'clear'> = actions;
export {
  reducer as ViewSwimlaneReducer,
  namespace as ViewSwimlaneNamespace,
  selectors as ViewSwimlaneSelectors,
};
